var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinDesktopSave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 14,
  fill: "none",
  viewBox: "0 0 10 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "m8 9.51-3-2.7-3 2.7V2h5a1 1 0 0 1 1 1zM0 0v14l5-4.5 5 4.5V3a3 3 0 0 0-3-3z"
})));
export default SvgLinkedinDesktopSave;